/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { withRouter } from "react-router-dom";

import { Label } from "../../components/form";
import Calendar from "../../components/form/calendar";
import LeftInfoModal from "../../components/left-info-modal";
import SelectBox from "../../components/select-box/select-box";
import { SupplementsContainer } from "./supplements-style";
import { images } from "../../assets";

import { SupplementsContext } from "../../context/supplements/SupplementsContext";
import { withGeneral } from "../../context/mixin/with-general";
import SupplementsServices from "../../services/SupplementsServices";
import { getPolicyData } from "../../services/utils";
import { getRelatedMediatorsCodes } from "../../utils/mediatorCode";
import {
  generateArray,
  getTitles,
  getRemaindingDaysValidation,
  getRemaindingDays,
  getOnClickSupplementValidation
} from "./utils";
import {
  getBusinessGroup,
  getCollective,
  getSubramo,
  getPolicySupplementDay,
  setPolicyData,
  getPolicyEndDate
} from "../forms/supplements/utils";
import { stringDateFormat } from "../../utils/time";
import { Supplement, SupplementChild } from "../../services/SupplementsServices.dto";
import { SupplementsData, SupplementsProps } from "./supplement.types";

class SupplementsLayout extends React.Component<SupplementsProps, SupplementsData> {

    static contextType = SupplementsContext;
    context!: React.ContextType<typeof SupplementsContext>;

    constructor(props: SupplementsProps) {
        super(props);

        this.state = {
            mediatorCodesInput: {
                codeOptions: getRelatedMediatorsCodes(this.props.mediator),
                disabled: props.location.state && props.location.state.searchType ? false : true,
                showError: false,
                errorText: '',
                selectedCode: props.location.state && props.location.state.searchCode ? props.location.state.searchCode : props.mediator.mediatorCode,
            },
            fechaEfectoSuplemento: getPolicySupplementDay() || "",
            modalFechaEfectoSuplemento: {
              active: false,
              mainText: "",
            },
            modalErrorSuplementos: {
              active: false,
              mainText: "",
            },
            notSupplementsModal: false,
            supplements: [],
            subramo: getSubramo(),
            remaindingDays: 0,
        };
    };

    componentDidMount = () => {
      this.getSupplements();

      const { fechaEfectoSuplemento, remaindingDays: hasRemaindingDays } = this.state;
      if (fechaEfectoSuplemento && !hasRemaindingDays) {
          const endDate = getPolicyEndDate();
          const endDateFormated = stringDateFormat(endDate);
          const remaindingDays = getRemaindingDays(fechaEfectoSuplemento, endDateFormated);
          this.setState({ remaindingDays });
      }

      const policyCodRamo = localStorage.getItem('policyCodRamo');
      this.context.setIsLife(policyCodRamo === "4");
    }

    getSupplements = async () => {
      const args = {
        loader: true,
        setLoading: this.props.setLoading,
        collective: getCollective(),
        businessGroup: getBusinessGroup(),
        subramo: getSubramo(),
      }
      const response = await SupplementsServices.getSupplements(args);
      if (response.ok) {
        const supplements = response.data;
        if (supplements.length === 0) {
          this.setState({ notSupplementsModal: true });
        } else {
          this.setState({ supplements });
          generateArray(response.data);
        }
        this.context.setSupplements(response.data);
      } else {
        this.setState({ modalErrorSuplementos: { active: true, mainText: response.message }});
      }
    }

    handleSelectedCodesChange = (selectedCode: string) => {
        const { mediatorCodesInput } = this.state;
        mediatorCodesInput.selectedCode = selectedCode;
        this.setState({ mediatorCodesInput });
    };

    handleOnClickSupplement = (supplementData: { link: string, supplementId: number, childId: number }) => {
        const newChildIs = supplementData.childId ? [supplementData.childId] : []; 
        this.context.setSupplementId(supplementData.supplementId);
        this.context.setSupplementChildIds(newChildIs);

        const { fechaEfectoSuplemento, subramo, remaindingDays } = this.state;
        const { warning, modalMainText } = getOnClickSupplementValidation({ 
            fechaEfectoSuplemento,
            subramo,
            remaindingDays,
            id: supplementData.link,
            literales: this.props.literales,
        });
        if (warning) {
            this.setState({
                modalFechaEfectoSuplemento: {
                  active: true,
                  mainText: modalMainText,
                }
            });
            return;
        }

        this.props.history.push({
            pathname: '/suplemento' + supplementData.link,
            state: { mediator: this.state.mediatorCodesInput.selectedCode }
            //search: '?mediador='+this.state.mediatorCodesInput.selectedCode,
        })
    };

    handleOnClickFechaEfectoSuplemento = (value: string) => {
      const { fechaEfectoSuplemento, subramo } = this.state;
      if (value === fechaEfectoSuplemento) return;

      this.setState({ fechaEfectoSuplemento: value });
      setPolicyData("fechaEfectoSuplemento", value);

      if (subramo.toUpperCase().includes("SALUD") || subramo.toUpperCase().includes("DENTAL")) {
        const { remaindingDays, modalMainText, warning } = getRemaindingDaysValidation(value, this.props.literales);
        this.setState({ remaindingDays });
        if (warning) {
          this.setState({
            modalFechaEfectoSuplemento: {
              active: true,
              mainText: modalMainText,
            }
          });
        }
      }
    };

    checkSupplement = (supplement: Supplement) => {
        const { user } = this.props;
        let allowedRoles = supplement.allowedRoles.split("-");
        return allowedRoles.some((x: string) => user.roles.includes(x));
    }

    _renderCol(data: Supplement[]) {
        const titles = getTitles();
        return (
            <ul className="container-menu">
                <LeftInfoModal
                  img={images.IconInfoGrey}
                  mainTitle={"Aviso"}
                  mainText={"No hay suplementos disponibles para este colectivo"}
                  buttonText={"Volver"}
                  noSecondaryButton={true}
                  active={this.state.notSupplementsModal}
                  close={() => this.props.history.goBack()}
                  className={"info"}
                />
                {data.map((supplement: Supplement, index: number) => {
                    if (supplement.title === titles.newIncorporation && (localStorage.getItem('policyOrigin') === 'GIP' || localStorage.getItem('policySubramo') !== 'ASISA SALUD') ) return null;
                    if (this.checkSupplement(supplement)) {
                        const oneChildId = supplement.child && supplement.child.length === 1 ? supplement.child[0].id : NaN;
                        return supplement.child ? (
                          <div key={index} className="width-45">
                            <div key={index} className="buttonText">
                              <li className="list-title">
                                {supplement.link ? (
                                  <a className="link" onClick={() => this.handleOnClickSupplement({ link: supplement.link || "", supplementId: supplement.id, childId: oneChildId })} >
                                    <strong>{supplement.title}</strong>{supplement.subTitle}
                                  </a>
                                ) : (
                                  <a className="no-link">
                                    <strong>{supplement.title}</strong>{supplement.subTitle}
                                  </a>
                                )}
                              </li>
                            </div>

                            {supplement.child && supplement.child.length !== 0  && (
                              <div className="list">
                                <p className="list-text">
                                  Dentro de esta categoría, se podrá modificar:
                                </p>
                                <ul className="list-child">
                                  {supplement.child.map(
                                    (child: SupplementChild, subIndex: number) => {
                                      return (
                                        <li key={subIndex}>
                                          {child.link ? (
                                            <a className="link" onClick={() => this.handleOnClickSupplement({ link: child.link || "", childId: child.id, supplementId: supplement.id })} >
                                                <strong>{child.title}</strong>
                                            </a>
                                          ) : (
                                            <a className="no-link" id={child.link || undefined} >
                                              {child.title}
                                            </a>
                                          )}
                                        </li>
                                      );
                                    }
                                  )}
                                </ul>
                              </div>
                            )}
                          </div>
                        ) : (
                          <div key={index} className="buttonText width-45">
                            <li className="list-title">
                              <a
                                className="link"
                                id={supplement.link || undefined}
                                onClick={() => this.handleOnClickSupplement({ link: supplement.link || "", supplementId: supplement.id || NaN, childId: NaN })}
                              >
                                <strong>{supplement.title}</strong>{" "}
                                {supplement.subTitle}
                              </a>
                            </li>
                          </div>
                        );
                    }
                    return null
                })}
            </ul>)
    }

    render() {
        const { mediatorCodesInput, supplements, modalFechaEfectoSuplemento, fechaEfectoSuplemento, modalErrorSuplementos } = this.state;
        // Una vez esten todos los formularios, estos serian los SLICE
        //const dataFirst = data.slice(0, 3);
        //const dataSecond = data.slice(3);
        // Mientras
        // const dataFirst = supplements.slice(0, 2);
        // const dataSecond = supplements.slice(2);

        return (
            <>
                <SupplementsContainer>
                    <h1>MODIFICACIONES / SUPLEMENTOS</h1>
                    <div className="supplements-filter-container">
                        <div className="col-6">
                            <div className="selectBox relatedMediators">
                                <SelectBox
                                    // mediatorSelector={true}
                                    isMediator={true}
                                    optionsText={getRelatedMediatorsCodes(this.props.mediator)}
                                    optionKey={"value"}
                                    optionValue={"label"}
                                    defaultValue={getPolicyData().mediator}
                                    onChange={(value: string) => this.handleSelectedCodesChange(value)}
                                    propValue={mediatorCodesInput.selectedCode}
                                    disabled
                                    required
                                />
                                <label>Mediador</label>
                            </div>
                        </div>

                        <div className="col-6">
                          <Label className="required old-style">Fecha de efecto de suplemento</Label>
                            <Calendar
                              required
                              value={fechaEfectoSuplemento}
                              onChange={(value: string) => this.handleOnClickFechaEfectoSuplemento(value)}
                            />
                        </div>
                    </div>

                    <div className="supplements-container">
                        <div className="supplements-row">
                            {this._renderCol(supplements)}
                            {/* <div className="col-6">

                                {this._renderCol(dataFirst)}

                            </div>
                            <div className="col-6">
                                {this._renderCol(dataSecond)}
                            </div> */}
                        </div>
                    </div>
                </SupplementsContainer>

                <LeftInfoModal
                  img={images.IconInfoGrey}
                  mainTitle="Aviso"
                  mainText={modalFechaEfectoSuplemento.mainText}
                  buttonText="Volver"
                  noSecondaryButton={true}
                  active={modalFechaEfectoSuplemento.active}
                  onClickAccept={() => this.setState({ modalFechaEfectoSuplemento: { active: false, mainText: "" }})}
                  className="info"
                  hasAcceptNoClose
                />
                <LeftInfoModal
                  img={images.IconWarningYellow}
                  className="warning"
                  mainTitle="Error en la recuperación de la lista de suplementos"
                  mainText={modalErrorSuplementos.mainText}
                  buttonText="Cerrar"
                  active={modalErrorSuplementos.active}
                  onClickAccept={() => this.setState({ modalErrorSuplementos: { active: false, mainText: "" }})}
                  close={() => this.setState({ modalErrorSuplementos: { active: false, mainText: "" }})}
                  noSecondaryButton
                />
            </>
        );
    }
}
export default withRouter(withGeneral(SupplementsLayout));